import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

type CopiarCotasApartamentoParams = {
  aptoOrigemId: number;
  aptoDestinoId: number;
};

export const copiarCotasApartamentoService = async ({
  aptoOrigemId,
  aptoDestinoId,
}: CopiarCotasApartamentoParams) => {
  const token = validateToken();

  if (!token) {
    throw new Error("Token invalido");
  }

  const url = `${Globais.DOMINIOBACK}/cota/apto/copiar`;

  try {
    const response = await axios.post(
      url,
      {
        aptoOrigemId,
        aptoDestinoId,
      },
      {
        headers: { Authorization: token.AuthStr },
      }
    );

    return response.data;
  } catch (error: any) {
    if (error.response?.data) {
      throw error.response.data;
    }

    throw new Error("Erro ao copiar cotas do apartamento");
  }
};
